import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";
import {  NumberGreaterThanZero } from "../../../../Validation/Validation";

export const CostMultipliersSchema: ISchema = {
    displayName: "Cost Multipliers",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'customerId',
            displayName: '',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            className: "small-12"
        } as ISchemaProperty,
        {
            name: 'multiplierType',
            displayName: 'Type',
            type: PropertyTypes.status,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            className: "small-12"
        } as ISchemaProperty,
        {
            name: 'multiplierTypeName',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            className: "small-12"
        } as ISchemaProperty,
        {
            name: 'value',
            displayName: 'Value',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
            validateRule: NumberGreaterThanZero as Function,
            validationError: "Value must be greater than zero",
        } as ISchemaProperty
    ],
}


